import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { PixHelpComponent } from '../../../help/help.component';

@Component({
  selector: 'app-anti-fraud',
  templateUrl: './anti-fraud.component.html',
  styleUrls: ['./anti-fraud.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class PixAntiFraudModalComponent {

  constructor(
		public dialogRef: MatDialogRef<PixAntiFraudModalComponent>,
		public dialog: MatDialog,
		public router: Router
	) { }

	close(): void {
		this.dialogRef.close();
	}

	openHelpModal(): void{
		this.openModal();
	}

	openModal()  {
		const dialogRef = this.dialog.open(PixHelpComponent, {
			width: '400px',
		});
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/payment-key/modal/anti-fraud/anti-fraud.component.ts